import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  faHome,
  faClipboardList,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { NAME_KEY } from "../constants/key.const";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { L } from "../langauge/english.lang";
import { useAuth } from "../contexts/AuthContext";
import ConfirmationModal from "./ConfirmationModal";
import { deleteUser } from "../services/userService";

const SideBar = ({ page }) => {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();
  const name = sessionStorage.getItem(NAME_KEY);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const isSuperUser = sessionStorage.getItem("SUPERUSER") === "true";

  const getGreeting = () => {
    const currentHour = new Date().getHours();

    if (currentHour >= 3 && currentHour < 12) {
      return L.GREETING_MORNING;
    } else if (currentHour >= 12 && currentHour < 18) {
      return L.GREETING_AFTER_NOON;
    } else {
      return L.GREETING_EVENING;
    }
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [links, setLinks] = useState([]);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let updatedLinks = [{ path: "/home", label: L.LINK.START, icon: faHome }];

    if (screenWidth > 500) {
      updatedLinks.push({
        path: "/overview",
        label: L.LINK.OVERVIEW,
        icon: faClipboardList,
      });

      if (isSuperUser) {
        updatedLinks.push({
          path: "/admin",
          label: L.LINK.ADMIN,
          icon: faUser,
        });
      }
    }

    setLinks(updatedLinks);
  }, [screenWidth, isSuperUser]);
  return (
    <>
      <div className="flex h-screen w-full relative">
        <div className="w-full">
          <div className="h-[76px] shadow-[0px_2px_3px_#bdbdbd] w-full flex space-x-4 px-6 py-[42px] items-center border-b-2">
            <div className="flex w-full h-full items-center justify-between">
              <img
                onClick={() => navigate("/")}
                src="/Logo1.png"
                className="sm:max-w-[330px] max-w-[130px] max-h-[70px] h-auto object-contain cursor-pointer"
                alt="logo"
              />

              <div className="flex items-center justify-end gap-5">
                {isSuperUser && page === L.LINK.ADMIN && (
                  <div className="flex gap-2">
                    <button
                      onClick={() => navigate("/add-user")}
                      className="px-3 py-2 bg-[#3667e9] text-white rounded cursor-pointer"
                    >
                      Add User
                    </button>
                    <button
                      onClick={() => navigate("/add-appointment")}
                      className="px-3 py-2 bg-[#3667e9] text-white rounded cursor-pointer"
                    >
                      Add Appointment
                    </button>
                  </div>
                )}

                <div
                  className="flex gap-3 md:gap-3 items-center cursor-pointer w-[90%]"
                  onClick={handleClick}
                >
                  <div className="flex flex-col">
                    <div className="text-[0.65rem] md:text-sm text-nowrap">
                      {getGreeting()}
                      <br />
                      <span className="text-right">{name}</span>
                    </div>
                    {/* <div>
                      <button
                        className="text-xs rounded-md bg-green-700 p-1 text-white"
                        onClick={() => navigate('/home/nextpatient/admin')}
                      >
                        Admin
                      </button>
                    </div> */}
                  </div>
                  <div className="p-2 rounded-xl bg-[#3666e917] text-darkblue mr-8">
                    <PermIdentityOutlinedIcon className="text-custom-green" />
                  </div>
                </div>

                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    onClick={logoutUser}
                    style={{ background: "#ffffff" }}
                  >
                    <LogoutOutlinedIcon
                      style={{ marginRight: "8px" }}
                      className="text-custom-green"
                    />
                    <span style={{ color: "#0B1423" }}>Logout</span>
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/change-password")}
                    style={{ background: "#ffffff" }}
                  >
                    <span style={{ color: "#0B1423" }}>Change Password</span>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>

          <Outlet />
        </div>

        <ConfirmationModal
          text="Are you sure want to delete your account ?"
          show={showModal}
          title="Alert"
          handleClose={(confirmed) => {
            setShowModal(false);
            if (confirmed) {
              deleteUser();
              logoutUser();
              navigate("/sign-in");
            }
          }}
        />
      </div>
    </>
  );
};

export default SideBar;
